import TextColumns from "@/Pages/TextColumns.vue"
export const textPanelsInit = {
    component: TextColumns,
    name: "Text Columns",
    inputs: [
        {
            name: "columns",
            friendlyName: "Columns",
            type: "list",
            subFields: [
                {
                    name: "title",
                    friendlyName: "Title",
                    type: "string"
                },
                {
                    name: "body",
                    friendlyName: "Body",
                    type: "string"
                }
            ],
            onChange: (options) => {
                if (options.get("columns").length > 4) {
                    options.set("columns", options.get("columns").slice(0, 4));
                    alert("Cannot exceed 4 Columns.");
                }
            }
        },
    ]
}